import { ReactNode } from 'react';

import {
  Tooltip,
  ExternalLink,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

import { PolicyCardForm } from './_components/PolicyCardForm';
import { WoopAgentCommand } from '../../../_components/WoopAgentCommand';
import { useVersionsInfo } from '../../../_hooks/useVersionsInfo';

import { RffCheckbox } from '@cast/shared-rff-ui';

import { getDocsLink } from '@cast/utils';

type AutoInstrumentFieldProps = {
  name: string;
  tooltipText?: ReactNode;
};

export const AutoInstrumentField = ({
  name,
  tooltipText,
}: AutoInstrumentFieldProps) => {
  const { isAutoInstrumentCannotBeUsed, latestVersion } = useVersionsInfo();

  return (
    <Tooltip
      wrapIf={isAutoInstrumentCannotBeUsed}
      title={
        <Stack
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
          }}
        >
          <span>
            Update required:&nbsp;
            <ExternalLink link={getDocsLink('docs_woop_upgrading')} noIcon>
              <Typography
                variant="P12B"
                color={tokens.theme.fg.selection.primary}
              >
                workload-autoscaler {latestVersion}
              </Typography>
            </ExternalLink>
          </span>
          <WoopAgentCommand />
        </Stack>
      }
    >
      <span>
        <PolicyCardForm
          label="Auto-instrument JVM workloads"
          tooltipText={tooltipText}
          control={
            <RffCheckbox
              name={name}
              size="small"
              testId="enable-auto-instrument"
              disabled={isAutoInstrumentCannotBeUsed || undefined}
            />
          }
        />
      </span>
    </Tooltip>
  );
};
